import { apiClient } from "@/lib/apiClient";

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role?: {
    id: string;
    name: string;
    description: string;
  };
  roleId: string;
  providers: string[];
  createdAt: string;
  updatedAt: string;
  address?: {
    id: string;
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
  company?: {
    id: string;
    name: string;
  };
  externalId?: string;
}

export interface CreateUserData {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  roleId: string;
  companyId?: string;
  address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
}

export interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  roleId: string;
  companyId?: string | null;
  address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
  };
}

class UserApiService {
  async getAllUsers(companyId?: string): Promise<User[]> {
    const params = new URLSearchParams();
    if (companyId) {
      params.set("companyId", companyId);
    }

    const endpoint = `/v1/users${
      params.toString() ? `?${params.toString()}` : ""
    }`;
    return apiClient.get<User[]>(endpoint);
  }

  async getUser(id: string): Promise<User> {
    return apiClient.get<User>(`/v1/users/${id}`);
  }

  async createUser(userData: CreateUserData): Promise<User> {
    return apiClient.post<User>(`/v1/users`, { data: userData });
  }

  async updateUser(id: string, userData: UpdateUserData): Promise<User> {
    return apiClient.put<User>(`/v1/users/${id}`, { data: userData });
  }

  async deleteUser(id: string): Promise<void> {
    return apiClient.delete<void>(`/v1/users/${id}`);
  }
}

export const userApi = new UserApiService();
